import { TodoTranslate } from './todoTranslate.model';

const todoTranslateEN: TodoTranslate = {
  list: {
    title: 'Tasks',
    searchPlaceholder: 'Search tasks...',
    emptyState: 'No tasks found',
    emptyStateDetail: 'Create a new task using the button above',
    tabs: {
      all: 'All',
      pending: 'Pending',
      done: 'Done',
    },
  },
  form: {
    fields: {
      title: 'Title',
      description: 'Description',
      dueDate: 'Due date',
      dueDateHint:
        'Without a due date the task is left out of the daily e-mail reminder',
      association: 'Link to...',
      associationNone: 'None',
      associationLead: 'Lead',
      associationEvent: 'Event',
      lead: 'Lead',
      event: 'Event',
      leadSearchPlaceholder: 'Search lead',
      leadNoResults: 'No lead found',
      eventSearchPlaceholder: 'Search event',
      eventNoResults: 'No event found',
    },
    errors: {
      title: {
        required: 'Title is required',
        maxLength: 'Title must be at most 200 characters',
      },
      description: {
        maxLength: 'Description must be at most 500 characters',
      },
      dueDate: {
        invalid: 'Invalid date',
      },
      xor: 'A task cannot be linked to both a lead and an event at the same time',
    },
  },
  modal: {
    titleNew: 'New task',
    titleEdit: 'Editing task',
  },
  toast: {
    created: 'Task created successfully',
    updated: 'Task updated successfully',
    deleted: 'Task removed successfully',
    error: 'Error saving task',
  },
  card: {
    editLabel: 'Edit task',
    deleteLabel: 'Delete task',
    toggleLabel: 'Mark task "{{title}}" as done',
    due: {
      overdue: 'Overdue {{count}} day',
      today: 'Due today',
      tomorrow: 'Due tomorrow',
      inDays: 'Due in {{count}} days',
    },
  },
  widget: {
    title: 'Pending tasks',
    viewAll: 'View all',
    empty: 'No pending tasks',
  },
};

export default todoTranslateEN;
